<div [formGroup]="numberForm">
  <div class="control">
    <label for="number-input-{{ uniqueId }}"
      >{{ label }}<span class="required-indicator has-text-danger" *ngIf="required">*required</span></label
    >
    <input
      type="number"
      id="number-input-{{ uniqueId }}"
      class="input form-control"
      [ngClass]="{ 'is-danger': showErrors && numberForm.invalid }"
      [placeholder]="placeholder || label + '...'"
      [step]="step"
      [min]="min"
      [max]="max"
      inputmode="numeric"
      pattern="[0-9]*"
      formControlName="number"
      (keydown)="preventInvalidKeys($event)"
      (keyup)="onChange($event.target.value)"
      (change)="onChange($event.target.value)"
      (paste)="onPaste($event)"
    />
    <ng-container *ngIf="htmlHelpText; else plainText">
      <div
        class="content help mb-1"
        [innerHTML]="htmlHelpText"
        *ngIf="htmlHelpText"
      ></div>
    </ng-container>
    <ng-template #plainText>
      <p class="help mb-1" *ngIf="helpText">{{ helpText }}</p>
    </ng-template>
  </div>
</div>
